module.exports = __webpack_public_path__ + "img/arrowbackline.5c72e990.svg";